import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-2455106f-2e1f-4430-bcb3-8adfd52c7551-__Layer_1",
  height: "48px",
  viewBox: "0 0 1024 1024",
  width: "48px",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M 1012.717 241.668 L 796.113 530.805 L 557.118 849.844 C 534.599 879.903 489.52 879.903 467.001 849.844 L 228.006 530.805 L 11.402 241.668 C -1.651 224.712 -3.712 201.733 6.113 182.723 C 15.438 163.463 35.064 151.338 56.461 151.617 L 967.66 151.617 C 1010.999 151.617 1038.084 198.533 1016.415 236.065 C 1015.295 238.006 1014.06 239.877 1012.717 241.67 L 1012.717 241.668 Z",
      "fill-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }